import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask4500To4599Service {

  constructor() { }
}
